import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["renameForm", "title"]

  openForm() {
    var textInput = $(this.renameFormTarget).find("input[type=text]")

    $(this.renameFormTarget).show()

    // We want focus in the input, but at the end of it
    // This does the trick
    textInput.focus()
    var name = textInput.val()
    textInput.val("")
    textInput.val(name)

    $(this.titleTarget).hide()
  }

  closeForm() {
    $(this.renameFormTarget).hide()
    $(this.titleTarget).show()
  }
}
